<template>
    <div v-if="loading" class="auth-image-placeholder">
        <md-progress-spinner md-mode="indeterminate" :md-diameter="20" :md-stroke="2" />
    </div>
    <div v-else-if="error || !src" class="auth-image-placeholder">
        <md-icon>broken_image</md-icon>
    </div>
    <img v-else :src="src" :alt="alt" class="auth-image" @click="$emit('click')" />
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { downloadPlanningItemAttachment } from '@/resources/phrospr-api/planning-item.service';

// Attachment images require a bearer token, so they are fetched as a blob and
// shown via an object URL (port of the portal AuthImage).
@Component
export default class AuthImage extends Vue {
    @Prop({ required: true }) fileName: string;
    @Prop({ default: '' }) alt: string;

    src: string | null = null;
    loading = true;
    error = false;

    mounted() {
        this.fetchImage();
    }

    @Watch('fileName')
    onFileNameChange() {
        this.fetchImage();
    }

    beforeDestroy() {
        this.revoke();
    }

    private async fetchImage() {
        if (!this.fileName) return;
        this.loading = true;
        this.error = false;
        this.revoke();
        try {
            const blob = await downloadPlanningItemAttachment(this.fileName);
            this.src = URL.createObjectURL(blob);
        } catch (err) {
            console.error(err);
            this.error = true;
        } finally {
            this.loading = false;
        }
    }

    private revoke() {
        if (this.src) {
            URL.revokeObjectURL(this.src);
            this.src = null;
        }
    }
}
</script>

<style scoped>
.auth-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}

.auth-image-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f0f0;
}
</style>
